import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    // getLocationDictTreeApi,
    getLocationPageApi,
    getLocationListDataApi,
    postLocationDataApi,
    putLocationDataApi,
    deletLocationTableDataApi,
    getLocationIdDataApi,
    getLocationVesselOrCampDictTreeApi,
    getLocationDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    dictData: null, // 树形多选框字典
    locationData: null, // 场所信息列表
    locationName: '', // location 名称
    locationId: '', // location id
    locationType: '', // location type
    callSign: '', // location callSign
    paginatedData: null, // 分页数据
    idData: null, // 单条回显数据
    pageNum: 1, // 初始分页数
}

/* 获取树形多选框字典 */
export const getLocationDictDataAction = createAsyncThunk(
    'LocationSlice/getLocationDictDataAction',
    async (params, thunkAPI) => {
        try {
            const dictData = await getLocationVesselOrCampDictTreeApi(params.locationType, params.locationId)
            return dictData
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取 location (船)列表 */
export const getLocationListDataAction = createAsyncThunk(
    'LocationSlice/getLocationListDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getLocationListDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 场所信息 */
export const getALocationDataAction = createAsyncThunk('HeaderSlice/getALocationDataAction', async (menuCode, thunkAPI) => {
    try {
        const { data } = await getLocationDataApi(menuCode)
        return data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 查询分页数据 */
export const getLocationPageAction = createAsyncThunk(
    'LocationSlice/getLocationPageAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getLocationPageApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 新增数据 */
export const postLocationDataAction = createAsyncThunk(
    'LocationSlice/postLocationDataAction',
    async ({ params, modalAddNew }, thunkAPI) => {
        try {
            if (modalAddNew) {
                delete params.id
                const data = await postLocationDataApi(params)
                return data
            } else {
                const data = await putLocationDataApi(params)
                return data
            }
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 删除 Location 表格单条数据 */
export const deletLocationTableDataAction = createAsyncThunk(
    'LocationSlice/deletLocationTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletLocationTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 通过 id 获取项目 */
export const getLocationIdDataAction = createAsyncThunk(
    'LocationSlice/getLocationIdDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await getLocationIdDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const LocationSlice = createSlice({
    name: 'LocationSlice',
    initialState,
    reducers: {
        changepPageNum: (state, action) => {
            state.pageNum = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
        /* location type */
        addlocationType: (state, action) => {
            state.locationType = action.payload
        },
        /* location callSign */
        addlocationCallSign: (state, action) => {
            state.callSign = action.payload
        },
        /* location data */
        addlocationData: (state, action) => {
            let data = [...state.locationData]

            if (data?.length >= 1) {
                data.unshift({ id: 'All Vessels', name: 'All Vessels' })
            }
            state.locationData = data
        },
        clearLocationType: (state, action) => {
            state.locationType = ''
        },
        /* location id */
        clearLocation: (state, action) => {
            state.locationId = ''
            state.locationName = ''
        },
    },
    extraReducers: {
        /* 处理树形多选框字典 */
        [getLocationDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* location (船)列表 */
        [getALocationDataAction.fulfilled.type]: (state, action) => {
            state.locationData = action.payload
        },

        /* 分页数据 */
        [getLocationPageAction.fulfilled.type]: (state, action) => {
            state.paginatedData = action.payload
        },

        /* 通过 ID 获取项目数据 */
        [getLocationIdDataAction.fulfilled.type]: (state, action) => {
            state.idData = action.payload
        },
    },
})
